import {
	AutoPopulationType,
	AutoPopulationDefinition as AutoPopulationDefinitionType,
} from '@amzn/snow-auto-population-service-typescript-client';
import {
	CaseHandlingType,
	DataType,
	InputType,
	ValidationDefinition,
	ValidationOperationConfig,
	ValidationParameter,
	ValidationParameterType,
	ValidationStatus,
	ValidationType,
} from '@amzn/snow-nxt-workflow-service-typescript-client';

export type {
	CaseHandlingType,
	DataType,
	InputType,
	ValidationDefinition,
	ValidationOperationConfig,
	ValidationParameter,
	ValidationParameterType,
};

export { ValidationStatus, ValidationType };

export const AUTO_POPULATION_TYPES = Object.values(AutoPopulationType).map((type) => ({
	label: type,
	value: type,
}));

export interface MappingEntry {
	key: string;
	value: string;
}

export type ValidationOperation = ValidationDefinition;

export type AutoPopulationDefinition = Required<Pick<AutoPopulationDefinitionType, 'autoPopulationId'>> &
	Omit<AutoPopulationDefinitionType, 'autoPopulationId'> & {
		validations?: ValidationDefinition[];
	};

export const VALIDATION_TYPES = Object.values(ValidationType).map((v) => ({ label: v, value: v }));
export const VALIDATION_STATUSES = Object.values(ValidationStatus).map((v) => ({ label: v, value: v }));
export const INPUT_TYPES = Object.values(InputType).map((v) => ({ label: v, value: v }));
export const CASE_HANDLING_TYPES = Object.values(CaseHandlingType).map((v) => ({ label: v, value: v }));
export const PARAM_DATA_TYPES = Object.values(DataType).map((v) => ({ label: v, value: v }));

export const createEmptyParameter = (): ValidationParameter => ({
	validationParameterName: '',
	validationParameterType: {},
	validationParameterValue: '',
	validationParameterCaseHandlingType: '',
	validationParameterDataType: '',
});

export const createEmptyValidation = (): ValidationDefinition => ({
	validationParameters: [],
	validationOperationConfig: { operationId: '', successCriteria: [], failureCriteria: [] },
});

export interface AttributeRow {
	attributeId: string;
	attributeName: string;
	dataType: string;
	autoPopulationId: string;
	validationId: string;
	taskName: string;
}

export const recordToEntries = (record?: Record<string, string>): MappingEntry[] =>
	Object.entries(record || {}).map(([key, value]) => ({ key, value }));

export const entriesToRecord = (entries: MappingEntry[]): Record<string, string> =>
	entries.reduce((acc, { key, value }) => {
		if (key) acc[key] = value;

		return acc;
	}, {} as Record<string, string>);
